module.exports = __webpack_public_path__ + "img/galery4.55c2122f.jpg";